var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 41 41"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.5.5C9.454.5.5 9.454.5 20.5s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20m-2.342 20.98L10.05 11h6.251l5.315 6.87L28.194 11h1.837l-7.595 7.931L31 30h-6.249l-5.771-7.46L11.837 30H10zm-2.537-9.172h-2.87l12.676 16.384h2.87z",
  clipRule: "evenodd"
})));
export default SvgX;